<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Track Information"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Title" label-position="inside">
                        <b-input v-model="track.title" maxlength="250"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>

    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";

    export default {
        name: 'TrackForm',
        props: {
            track: {
                type: Object,
                required: true
            },
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {
                type: null,
                title: null,
                componentSelect: null,
                components: [],
                editorOptions: {}
            };
        },
        computed: {},
        methods: {

        },
        mounted: function() {

        }
    };
</script>
